import { render, staticRenderFns } from "./detailVoList.vue?vue&type=template&id=2b983e7a&scoped=true&"
import script from "./detailVoList.vue?vue&type=script&lang=js&"
export * from "./detailVoList.vue?vue&type=script&lang=js&"
import style0 from "./detailVoList.vue?vue&type=style&index=0&id=2b983e7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b983e7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b983e7a')) {
      api.createRecord('2b983e7a', component.options)
    } else {
      api.reload('2b983e7a', component.options)
    }
    module.hot.accept("./detailVoList.vue?vue&type=template&id=2b983e7a&scoped=true&", function () {
      api.rerender('2b983e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/remote_code_scanning_report_main/form/detailVoList.vue"
export default component.exports